// React&NextJS
import React from 'react'
import { useState } from 'react'
// 3rd party libraries
import { motion } from 'framer-motion'
// Services&Helper functions
// import trimText from './TrimText'
import ReadOnlyObituaryPlate from '../../components/plate/ReadObituaryPlate'
// Types
import { PlateObj } from '../../../types/types'
// Styles
import s from './ObituaryCard.module.scss'
import c from 'classnames'
// Components
import { Button } from '../../core/button/Button'

import { Image } from '../../core/image/Image'
// import Share from '../../components/share/Share'
import { Text } from '../../core/text/Text'
import Share from '../../components/share/Share'
import Gallery from '../../components/gallery/Gallery'
import GallerySlider from '../../components/gallerySlider/GallerySlider'
import { Icon } from '../../core/icon/Icon'
// import Gallery from '../../components/gallery/Gallery'

// const GallerySlider = dynamic(
//     () => import('../../components/gallerySlider/GallerySlider'),
//     {
//         ssr: false,
//     }
// )

// const Gallery = dynamic(() => import('../../components/gallery/Gallery'), {
//     ssr: false,
// })

type Props = {
    headerImage?: string
    jsxObituary?: Array<PlateObj>
    gallery?: Array<string>
    read?: boolean
    mid?: string
    oid?: string
    isDefault?: boolean
    disabled?: boolean
    animation?: boolean
    [key: string]: unknown
    className?: string
}

export default function ObituaryCard({
    jsxObituary,
    gallery,
    headerImage,
    mid,
    oid,
    className,
    disabled,
    animation = true,
}: Props) {
    let nodes = jsxObituary

    function Card() {
        const [isExpanded, setIsExpanded] = useState(!animation)
        const [showGallery, setShowGallery] = useState(false)
        const [index, setIndex] = useState(0)
        const [openModal, setOpenModal] = useState<boolean>(false)

        let html = ReadOnlyObituaryPlate({
            nodes,
        })

        let obitText
        if (Array.isArray(html)) {
            obitText = html.slice(0, 2)
            if (obitText.length === 2) {
                // Dont allow two headers or two paragraphs in collapsed view
                if (obitText[0].type === obitText[1].type) {
                    obitText = obitText[0]
                }
            }
        } else {
            obitText = html
        }

        const mainImageHandler = () => {
            if (!disabled) {
                setIndex(gallery.indexOf(headerImage))
                setShowGallery((prev) => !prev)
            }
        }

        let expandedText = html
        const toggleExpanded = () => setIsExpanded(!isExpanded)
        return (
            <>
                {/* Share modal */}
                {!disabled && (
                    <Share
                        url={`https://minningar.is/memories/${mid}?shared=obit&obit=${oid}#${oid}`}
                        isOpen={openModal}
                        setOpenModal={setOpenModal}
                    />
                )}
                {/* Open gallery with selected image/index */}
                {showGallery && (
                    <Gallery
                        gallery={gallery}
                        index={index}
                        showModal={showGallery}
                        setShowModal={setShowGallery}
                    />
                )}
                <motion.div
                    layout
                    className={c(className, s.card)}
                    initial={{ borderRadius: 10 }}
                    id={oid}
                >
                    <div className={s.main_content}>
                        {/* Text content */}
                        <div
                            className={c(
                                s.text_content,
                                isExpanded && s.expanded,
                                !isExpanded && s.not_expanded
                            )}
                        >
                            {/* <motion.div layout>
                            <Text variant="h6">{header}</Text>
                        </motion.div> */}

                            {isExpanded && (
                                <motion.div layout>{expandedText}</motion.div>
                            )}
                            {!isExpanded && (
                                // <motion.p layout>{collapsedText}</motion.p>
                                <motion.div layout>{obitText}</motion.div>
                            )}
                        </div>

                        {headerImage && (
                            // Extra div is hack. cant put motion with classname
                            <div
                                className={s.header_image}
                                style={disabled ? {} : { cursor: 'pointer' }}
                            >
                                <motion.div>
                                    <Image
                                        lazy
                                        alt=""
                                        src={headerImage}
                                        layout
                                        className={s.header_image}
                                        onClick={mainImageHandler}
                                    />
                                </motion.div>
                            </div>
                        )}
                    </div>

                    {isExpanded && (
                        <div className={s.gallery}>
                            {/* <motion.div layout> */}
                            <GallerySlider
                                style="obituary"
                                gallery={gallery}
                                disabled={disabled ? true : false}
                                setShowModal={setShowGallery}
                                setIndex={setIndex}
                            />
                            {/* </motion.div> */}
                        </div>
                    )}
                    {animation && (
                        <motion.div
                            layout
                            style={{ background: 'white' }}
                            className={s.buttons}
                        >
                            <Button
                                variant="arrow"
                                arrowDirection={isExpanded ? 'u' : 'd'}
                                label={isExpanded ? 'Lesa minna' : 'Lesa meira'}
                                onClick={toggleExpanded}
                            />
                            {!disabled && (
                                <Button
                                    variant="arrow"
                                    icon="share"
                                    onClick={() =>
                                        setOpenModal((prev) => !prev)
                                    }
                                    className={s.shareBtn}
                                >
                                    Deila minningargrein
                                </Button>
                            )}
                        </motion.div>
                    )}
                    {!disabled && (
                        <div
                            className={s.icon_share}
                            onClick={() => setOpenModal((prev) => !prev)}
                        >
                            <Icon variant="share" data-share-button />
                        </div>
                    )}
                </motion.div>
            </>
        )
    }

    if (!nodes) {
        return (
            <div className={c(className, s.default_card)}>
                <div>
                    <Text variant="h6">Ertu með minningargrein?</Text>
                    <Text variant="p">
                        Hér getur þú skrifað minningargrein eða sett inn
                        minningargrein sem hefur nú þegar verið skrifuð.
                    </Text>
                </div>
                <Image
                    className={s.default_image}
                    src="/images/obitDefaultImg.jpg"
                    alt=""
                    lazy
                />
                <Button
                    type="button"
                    variant="ghost"
                    to={`/memories/${mid}/obituaries/form`}
                    disabled={disabled}
                >
                    Skrifa minningargrein
                </Button>
            </div>
        )
    }

    return <Card />
}
